import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const CommentsIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.76 2.667h11.037v8H3.567l-.808.78v-8.78zm0-1.334c-.76 0-1.373.6-1.373 1.334l-.007 12L4.14 12h9.657c.76 0 1.38-.6 1.38-1.333v-8c0-.734-.62-1.334-1.38-1.334H2.76zM4.14 7.5H9v1.333H4.14V7.5zm0-3h8.278v1.333H4.139V4.5z" fill={color} />
    <path fill="#fff" d="M9 7h7v5H9z" />
    <path d="M10.938 8.465l2.015.098 2.962 2.904.627.614c.578.566.608 1.534.138 2.012-.469.479-1.436.469-2.014-.098l-.584-.572-3.005-2.946-.139-2.012z" fill="#fff" />
    <path d="M14.082 13.423l-3.005-2.946-.139-2.012 2.015.098 2.962 2.904m-1.832 1.956l.583.572c.578.567 1.545.577 2.014.098.47-.478.44-1.446-.138-2.012l-.627-.614m-1.832 1.956l1.832-1.956" stroke={color} strokeWidth="1.3" />
  </svg>
);

CommentsIcon.propTypes = {
  color: string.isRequired,
  fillOpacity: number,
  ...helpers.iconDimensionsPropTypes,
};

CommentsIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(19, 16),
};

export default CommentsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/comments.js